// extracted by mini-css-extract-plugin
module.exports = {"top":"Layout_top__1tn9b","topBottomGutter":"Layout_topBottomGutter__3kSSJ"};